import { BaseService } from './BaseService';
import { ConfigApi } from '../config/Constantes';

class SenhaErpService extends BaseService {
  constructor() {
    super(`${ConfigApi.senhaErpURL}`);
  }

  getFilter() {
    return new Filter();
  }

  async geraSenhaErp() {
    this.setLoading(true);
    try {
      const response = await this.api.get(`${this.url}`);
      return response.data;
    } finally {
      this.setLoading(false);
    }
  }
}

class Filter {
  constructor() {
    this.resumo = '';
    this.limit = 11;
    this.page = 0;
  }
}
export default new SenhaErpService();
